<template>
  <b-modal v-model="show" :title="$t('config.productCategory.title')" :no-close-on-esc="true"
           :no-close-on-backdrop="true">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Номи <span class="red">*</span></label>
            <input
                type="text"
                class="form-control"
                v-model="productCategory.name"
                :class="{'is-invalid': $v.productCategory.name.$error}"
                @blur="$v.productCategory.name.$touch()"
            />
            <div class="red" v-if="$v.productCategory.name.$error">Номи</div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
      <button class="all-btn add-btn float-right" @click="save">
        Сақлаш
      </button>
      <button class="all-btn delete-btn float-right mr-2" @click="cancel">
        Бекор қилиш
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import {required} from 'vuelidate/lib/validators'
import initFilterModel from '@/shared/filter';

export default {
  name: "ProductCategoryAddView",
  components: {
    'b-modal': bModal
  },
  directives: {
    'b-modal': bModalDirective
  },
  data() {
    return {
      show: false,
      processing: false,
      categoryFilter: initFilterModel(),
      productCategory: {
        id: null,
        name: ''
      }
    }
  },
  validations: {
    productCategory: {
      name: {
        required: required
      }
    }
  },
  methods: {
    cancel() {
      this.show = false;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const vm = this;
      this.processing = true;

      this.$http.post('product-category-plus/save', this.productCategory)
          .then(res => {
            vm.processing = false;
            const response = res.data;
            if (response.statusCode === 'OK') {
              vm.show = false;
              this.$eventBus.$emit('productCategoryChanged', response);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.message,
                type: 'warning'
              });
            }
          }, err => {
            vm.processing = false;
            console.log(err);
          });
    }
  },
  created() {
    this.$eventBus.$on('showProductCategoryModal', () => {
      this.show = true;
    });
  }
}
</script>

<style scoped>

</style>